import xs from "xstream"
import * as superagent from "superagent"
import * as R from "ramda"
import { nopListener } from "../utils"
import { API, AUTHORIZATION } from "../constant"

interface ReceiptRequest {
  date: string,
  id: string
}

export const makeReceiptDownloadDriver = () => {
	const source$ = xs.create().startWith(false)

	return sink$ => {
    sink$
    .map(({ date, id }: ReceiptRequest) => {
      const url = API.reciptDownload(id, date)
      
      superagent.get(url)
        .set({
          "Authorization": AUTHORIZATION,
        })
        .end((err, res) => {
          source$.shamefullySendNext(false)
          const message = R.path(["body", "message"], res)
          if (err) {
            alert(err)
            return
          } else if (message) {
            alert(message)
            return
          } 
          const dlUrl = R.path(["body", "data", "dlUrl"], res)
          if (dlUrl) {
            window['location']['href'] = dlUrl
          } else {
            alert("DLデータがみつかりませんでした。")
          }
        })
      source$.shamefullySendNext(true)
    })
    .addListener(nopListener("messageDialog"))
    return source$
  }
}